import { render } from "./anonymous-layout.vue?vue&type=template&id=b0ce2bc4"
import script from "./anonymous-layout.vue?vue&type=script&lang=js"
export * from "./anonymous-layout.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./anonymous-layout.vue?vue&type=style&index=0&id=b0ce2bc4&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__